import { forwardRef } from 'react';

// mui
import { Box } from '@mui/material';

// Reusable styled-scrollbar rules so any scrollable surface (ContainerScroll,
// dialog paper, etc.) shares the same look instead of the default browser scrollbar.
const scrollbarSx = (theme) => ({
    '&::-webkit-scrollbar': {
        width: '6px',
        height: '0px', // ✅ 가로 스크롤바 높이를 0으로 제거
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.scrollbar.thumb,
        borderRadius: '6px',
        transition: 'background-color 0.3s ease',
    },
    '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: theme.palette.scrollbar.thumbHover,
    },
    '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
    },
});

const ContainerScroll = forwardRef(({ children, sx, ...props }, ref) => (
    <Box
        ref={ref}
        sx={(theme) => ({
            height: '100%',
            overflowX: 'hidden !important',
            overflowY: 'auto',
            position: 'relative',
            ...scrollbarSx(theme),
            ...(typeof sx === 'function' ? sx(theme) : sx),
        })}
        {...props}>
        {children}
    </Box>
));

ContainerScroll.displayName = 'ContainerScroll';

export { ContainerScroll, scrollbarSx };
